import React, { useState } from "react";
import { cn } from "../../lib/cn";

export function PanelStub() {
  return null;
}
PanelStub._antdPanel = true;

export function Collapse({
  accordion = false,
  bordered = true,
  ghost,
  defaultActiveKey,
  activeKey: activeProp,
  children,
  className,
}) {
  const panels = [];

  React.Children.forEach(children, (ch, idx) => {
    if (!React.isValidElement(ch) || !ch.type?._antdPanel) return;
    panels.push({
      key: String(ch.key ?? idx),
      header: ch.props.header,
      content: ch.props.children,
    });
  });

  const [accOpen, setAccOpen] = useState(
    () =>
      accordion && defaultActiveKey != null ? String(defaultActiveKey) : null
  );
  const [multiOpen, setMultiOpen] = useState(() => {
    if (!accordion && defaultActiveKey != null) {
      return Array.isArray(defaultActiveKey)
        ? new Set(defaultActiveKey.map(String))
        : new Set([String(defaultActiveKey)]);
    }
    return new Set();
  });

  function expanded(k) {
    const ks = String(k);
    if (accordion) {
      const cur =
        activeProp !== undefined && activeProp !== null
          ? String(activeProp)
          : accOpen;
      return cur === ks;
    }
    const list =
      activeProp !== undefined && activeProp !== null
        ? new Set(Array.isArray(activeProp) ? activeProp.map(String) : [String(activeProp)])
        : multiOpen;
    return list.has(ks);
  }

  function toggle(k) {
    const ks = String(k);
    if (accordion) {
      if (activeProp !== undefined) return;
      setAccOpen((prev) => (prev === ks ? null : ks));
      return;
    }
    if (activeProp !== undefined) return;
    setMultiOpen((prev) => {
      const next = new Set(prev);
      if (next.has(ks)) next.delete(ks);
      else next.add(ks);
      return next;
    });
  }

  return (
    <div className={className}>
      {panels.map((p) => {
        const isOpen = expanded(p.key);
        return (
          <div
            key={p.key}
            className={cn(
              "mb-3 overflow-hidden rounded-xl",
              bordered !== false ? "border border-slate-200" : "",
              ghost && "!border-transparent"
            )}
          >
            <button
              type="button"
              className="flex w-full items-center justify-between bg-slate-50 px-4 py-3 text-left text-sm font-semibold text-slate-900 hover:bg-slate-100"
              onClick={() => toggle(p.key)}
            >
              <span>{p.header}</span>
              <span className="text-slate-400">{isOpen ? "−" : "+"}</span>
            </button>
            {isOpen ? (
              <div
                className={cn(
                  "border-t border-slate-100 bg-white px-4 py-4 text-sm leading-relaxed",
                  ghost && "border-0 bg-transparent"
                )}
              >
                {p.content}
              </div>
            ) : null}
          </div>
        );
      })}
    </div>
  );
}

Collapse.Panel = PanelStub;
